module.exports = __webpack_public_path__ + "components/page-footer/static/tide-forecast__logo--white-1f0ba92a39378ea19fa24aece5b69094.png";